import { ExpenseCategory } from '../enums/expense-category.enum';

/** Slug conocido → clave de traducción. */
export const EXPENSE_CATEGORY_LABEL: Readonly<Record<string, string>> = {
  'fuel-not-included': 'expenses.category.fuel',
  toll: 'expenses.category.toll',
  parking: 'expenses.category.parking',
  wash: 'expenses.category.wash',
  workshop: 'expenses.category.workshop',
  'payment-itv': 'expenses.category.itv',
  'waiting-time': 'expenses.category.waiting_time',
};

/**
 * Etiqueta a mostrar para una categoría.
 *
 * Unión discriminada: `translate` cuando el slug es conocido y `literal` cuando
 * no lo es, de forma que una categoría nueva (o un código numérico del
 * histórico) se vea literal en pantalla en lugar de desaparecer bajo un «Otros»
 * que perdería información para el equipo de operaciones.
 */
export type ExpenseCategoryLabel =
  | { kind: 'translate'; value: string }
  | { kind: 'literal'; value: string };

export function expenseCategoryLabel(
  category: ExpenseCategory | null | undefined
): ExpenseCategoryLabel {
  if (!category) {
    return { kind: 'literal', value: '—' };
  }

  const key = EXPENSE_CATEGORY_LABEL[category];

  return key
    ? { kind: 'translate', value: key }
    : { kind: 'literal', value: category };
}
